export const nav = [
  {
    type: 'section',
    title: '',
    items: [
      {
        type: 'link',
        title: 'Dashboard',
        name: 'dashboard',
        path: '/dashboard',
        data_tour: 'dashboard'
      }
    ]
  },
  {
    type: 'section',
    title: '',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Organisations',
        name: 'groups',
        path: '/organizations',
        data_tour: 'organizations'
      },
      {
        type: 'link',
        title: 'Billing',
        name: 'payments',
        path: '/billing',
        data_tour: 'billing'
      }
    ]
  }
];
